import { ICountryMySuffix } from 'src/app/shared/model//country-my-suffix.model';
import { ICargoGroupMySuffix } from './cargo-group-my-suffix.model';

export const enum ActiveStatus {
    ACTIVE = 'ACTIVE',
    IN_ACTIVE = 'IN_ACTIVE'
}

export interface ISanctionedGroupMySuffix {
    id?: number;
    name?: string;
    activeStatus?: ActiveStatus;
    countryLists?: ICountryMySuffix[];
    lastModifiedBy?: string;
    createdByUserRole?: string;
    lastModifiedByUserRole?: string;
    fromEffectiveDate?:string;
    cargoLists?: ICargoGroupMySuffix[];
    cargoCountryList?:CargoCountryList[]
}

export class SanctionedGroupMySuffix implements ISanctionedGroupMySuffix {
    constructor(
        public id?: number,
        public name?: string,
        public activeStatus?: ActiveStatus,
        public countryLists?: ICountryMySuffix[],
        public lastModifiedBy?: string,
        public createdByUserRole?: string,
        public lastModifiedByUserRole?: string,
        public fromEffectiveDate?:string,
        public cargoLists?: ICargoGroupMySuffix[]
    ) {
        this.activeStatus = ActiveStatus.ACTIVE;
    }
}

export class CargoCountryList {
    constructor(
        public id?:number,
        public country?: ICountryMySuffix,
        public cargoLists?: ICargoGroupMySuffix[]
    ) {
        // this.cargoLists = []
    }
}
